import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white p-6 mt-auto border-t">
      <div className="container mx-auto text-center">
        <p className="text-gray-400 text-sm mb-2">
          {t("footer.copyright", { year: currentYear })}
        </p>
        <Link
          target="_blank"
          to="/terms-of-service.html"
          className="text-gray-400 hover:text-white text-sm underline"
        >
          {t("footer.termsOfService")}
        </Link>{" "}
        <Link
          target="_blank"
          to="/privacy-policy.html"
          className="text-gray-400 hover:text-white text-sm underline"
        >
          {t("footer.privacyPolicy")}
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
